import {Severity, useSnackbarStore} from "../store/snackbarStore";

export const showMessage = (message: string, severity: Severity = 'success', duration: number | null = 5000) => {
    useSnackbarStore.getState().showMessage(message, severity, duration)
};
